<template>
    <div class="container pt-2">
        <PageTitle main="Notificações" sub="Cadastrar, alterar ou deletar notificações" />
        <b-form>
            <input id="notificacao-id" type="hidden" v-model="notificacao.id" />
            <div class="row">
                <div class="col-md-3">
                    <b-form-group label="Chave:" label-for="notificacao-name">
                        <b-form-input id="notificacao-name" type="text" disabled
                            v-model="notificacao.name"
                            :class="{ 'inputError': $v.notificacao.name.$error }"
                            class="textInput"
                            @keydown.tab="$v.notificacao.name.$touch"/>
                        <span class="error" v-if="!$v.notificacao.name.required && $v.notificacao.name.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.notificacao.name.minLength && $v.notificacao.name.$error">Precisa ter no mínimo 2 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-2">
                    <b-form-group label="Disponível para Email">
                        <b-form-radio-group
                            :disabled="!editando"
                            v-model="notificacao.email"
                            :options="options"
                            name="email"
                        ></b-form-radio-group>
                    </b-form-group>
                </div>
                <div class="col-md-1">
                    <b-button variant="info" @click="testEmail" class="botaoInput" :disabled="!editando">Testar</b-button>
                </div>
                <div class="col-md-2">
                    <b-form-group label="Disponível para Push">
                        <b-form-radio-group
                            :disabled="!editando"
                            v-model="notificacao.push"
                            :options="options"
                            name="push"
                        ></b-form-radio-group>
                    </b-form-group>
                </div>
                <div class="col-md-1">
                    <b-button variant="info" @click="testPush" class="botaoInput" :disabled="!editando">Testar</b-button>
                </div>
                <div class="col-md-2">
                    <b-form-group label="Disponível para SMS">
                        <b-form-radio-group
                            disabled
                            v-model="notificacao.sms"
                            :options="options"
                            name="sms"
                        ></b-form-radio-group>
                    </b-form-group>
                </div>
                <div class="col-md-1">
                    <b-button variant="info" @click="testSms" class="botaoInput" disabled>Testar</b-button>
                </div>
            </div>
            <b-button variant="outline-success" @click="save" class="botaoInput" v-if="editando">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 botaoInput" @click="reset" v-if="editando">Cancelar</b-button>
        </b-form>
        <hr>        
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        class="textInput"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" class="botaoInput" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-notificacao" 
                class="text-center table table-sm" 
                :items="notificacoes" 
                :fields="fields" 
                per-page="5"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 btn-size" @click="loadNotificacao(data.item)">
                        <i class="far fa-edit text-white"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="5"
                aria-controls="table-notificacao"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        class="textInput"
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" class="botaoInput" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-notificacao" 
                class="text-center table table-sm" 
                :items="notificacoes" 
                :fields="fields" 
                per-page="5"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 btn-size" @click="loadNotificacao(data.item)">
                        <i class="far fa-edit text-white"></i>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                size="sm"
                v-model="currentPage"
                :total-rows="rows"
                per-page="5"
                aria-controls="table-notificacao"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
import { mask } from 'vue-the-mask'
import { required, minLength } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'notificacao',
    components: { PageTitle },
    directives: { mask },
    data: function() {
        return {
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            jwt: new VueEasyJwt(),
            level: '',
            quemRecebeu: '',
            nome: '',
            email: '',
            notificacao: {},
            notificacoes: [],
            fields: [
                { key: 'name', label: 'Chave', sortable: true, thClass: 'tituloTabela', tdClass: 'fieldsTabela' },
                { key: 'email', label: 'Email', sortable: true, formatter: (value) => {
                    return value==='1' ? 'Sim' : 'Não' }, thClass: 'tituloTabela', tdClass: 'fieldsTabela'},
                { key: 'push', label: 'Push', sortable: true, formatter: (value) => {
                    return value==='1' ? 'Sim' : 'Não' }, thClass: 'tituloTabela', tdClass: 'fieldsTabela'},
                { key: 'sms', label: 'SMS', sortable: true, formatter: (value) => {
                    return value==='1' ? 'Sim' : 'Não' }, thClass: 'tituloTabela', tdClass: 'fieldsTabela'},
                { key: 'actions', label: 'Ações', thClass: 'tituloTabela', tdClass: 'actionsTabela' }
            ],
            options: [
                { text: 'Sim', value: '1' },
                { text: 'Não', value: '0' }
            ],
            larguraTela: 0,
            overflowValue: 'auto',
            editando: false
        }
    },
    computed: {
        ...mapState(['user']),
        rows() {
            return this.notificacoes.length
        }
    },
    validations: {
        notificacao: {
            name: {
                required,
                minLength: minLength(2)
            }
        }
    },
    methods: {
        testEmail() {
            const tipo = `?tipo=${this.notificacao.name}`
            const destinoEmail = `&destinoEmail=${this.email}`
            const destinoNome = `&destinoNome=${this.nome}`
            if(tipo.indexOf('Cliente') > -1){
                axios.get(`${baseApiUrl}/backend/mailCliente.php${tipo}${destinoEmail}${destinoNome}`).then({
                })
            } else if(tipo.indexOf('Funcionario') > -1){
                axios.get(`${baseApiUrl}/backend/mailFuncionario.php${tipo}${destinoEmail}${destinoNome}`).then({
                })
            } else if(tipo.indexOf('Motorista') > -1){
                axios.get(`${baseApiUrl}/backend/mailMotorista.php${tipo}${destinoEmail}${destinoNome}`).then({
                })
            } else if(tipo.indexOf('Empresa') > -1){
                axios.get(`${baseApiUrl}/backend/mailEmpresa.php${tipo}${destinoEmail}${destinoNome}`).then({
                })
            }
        },
        testPush() {
            console.log('Push')
        },
        testSms() {
            console.log('Sms')
        },
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        loadNotificacoes() {
            const url = `${baseApiUrl}/backend/notificacoes.php`
            axios.get(url).then(res => {
                this.notificacoes = res.data
                if(this.notificacoes.length > 0) {
                    this.exibeRodape = false
                }else{
                    this.exibeRodape = true
                }
            })
        },
        reset() {
            this.notificacao = {}
            this.loadNotificacoes()
            this.$v.notificacao.$reset()
            this.editando = false
        },
        save() {
            this.$v.notificacao.$touch()
            if(!this.$v.notificacao.$error){
                const method = this.notificacao.id ? 'put' : 'post'
                const id = this.notificacao.id ? `?id=${this.notificacao.id}` : ''
                axios[method](`${baseApiUrl}/backend/notificacoes.php${id}`, this.notificacao)
                    .then(() => {
                        if (method == 'post'){
                            this.$toasted.global.defaultSuccess({ message : 'Notificação inserida com sucesso!' })
                        } else {
                            this.$toasted.global.defaultSuccess({ message : 'Notificação alterada com sucesso!' })
                        }
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        loadNotificacao(notificacao) {
            this.notificacao = { ...notificacao }
            this.editando = true
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.level = decodedToken['data'].level
                this.quemRecebeu = decodedToken['data'].id
                this.nome = decodedToken['data'].nome
                this.email = decodedToken['data'].email
            }
        }
    },
    mounted() {
        this.validaLogin()
        if (this.level === 'cliente') {
            this.$router.push('/')
        } else if (this.level === 'motorista') {
            this.$router.push('/')
        }
        this.loadNotificacoes()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.notificacoes.length
        this.editando = false
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

.textInput {
    border: 1px solid rgb(220, 220, 220);
    outline: 0 !important;
    border-radius: 0px !important;
    background-color: transparent !important;
    font-size: 0.8rem !important;
}

.botaoInput {
    font-size: 0.8rem !important;
    border-radius: 0px !important;
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border: 1px solid #f57f6c !important;
}

.btn-size {
    width: 30px;
    height: 30px;
    border-radius: 0;
}

.text-custom {
    font-size: 0.8rem;
}

.actionsTabela {
    max-width: 30px;
    vertical-align: middle;
}

.fieldsTabela {
    vertical-align: middle !important;
    font-size: 0.8rem;
}

.tituloTabela {
    font-weight: normal;
    font-style: italic;
    font-size: 0.9rem;
}

label, legend {
    font-size: 0.8rem !important;
}
</style>